import { GetServerSidePropsContext } from 'next'
import setCookie from './setCookie'

/** @deprecated */
export default function usingLocale(
  context: GetServerSidePropsContext,
  country: string,
  language: string
): { country: string; language: string } {
  setCookie(context.res, 'country', country, false)
  setCookie(context.res, 'language', language, false)

  return { country, language }
}
